import { createSlice } from '@reduxjs/toolkit';
import api from 'api';
import formErrorsHandle from '../../../utils/formErrorsHandle';

const initialState = {
  loading: false,
  payorsItemsList: []
};
const payorItems = createSlice({
  name: 'payorItems',
  initialState,
  reducers: {
    setLoading(state, action) {
      return {
        ...state,
        loading: action.payload
      };
    },
    getList(state, action) {
      return {
        ...state,
        payorsList: action.payload?.data
      };
    }
  }
});

export const payorItemsActions = payorItems.actions;

export const getPayorItemsAction = (data) => async (dispatch) => {
  dispatch(payorItemsActions.setLoading(true));
  try {
    const res = await api.get(`api/PayorLevelOfService`, { params: data });
    if (res.status === 200 && res?.data) {
      dispatch(payorItemsActions.getList(res.data));
      return Promise.resolve(res?.data);
    }
  } catch (errors) {
    formErrorsHandle(errors.response?.data, []);
    return Promise.reject(errors.response?.data);
  } finally {
    dispatch(payorItemsActions.setLoading(false));
  }
};

export const createPayorItem = (data) => async () => {
  try {
    const res = await api.post(`api/PayorLevelOfService`, data);
    if (res.status === 200 && res?.data) {
      return Promise.resolve(res?.data);
    }
  } catch (errors) {
    return Promise.reject(errors.response?.data);
  }
};
export const editPayorItem = (data) => async () => {
  try {
    const res = await api.put(`api/PayorLevelOfService`, data);
    if (res.status === 200 && res?.data) {
      return Promise.resolve(res?.data);
    }
  } catch (errors) {
    return Promise.reject(errors.response?.data);
  }
};
export const clearPayorItemList = () => async (dispatch) => {
  dispatch(payorItemsActions.getList(''));
};

export default payorItems.reducer;
